export const SETTINGS_CATEGORIES = [
  {
    id: 'account',
    title: 'Account Settings',
    icon: 'applications',
    items: [
      {
        id: 'profile',
        label: 'Profile',
        icon: 'user',
        description: 'Update your personal information',
      },
    ],
  },
];

export const DEFAULT_SETTINGS_ITEM = 'profile';

